<template>
    <form @submit.prevent="createDeliveryType">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="deliveryType.name"
                name="name"
                type="text"
                placeholder="delivery type name"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-4">
            <label class="block mb-1" for="name_jpn">{{ $t('labels.name_jp') }}</label>
            <InputText
                v-model="deliveryType.name_jpn"
                name="name_jpn"
                type="text"
                placeholder="(Optional)"
                class="w-full"
                />      
                <p v-if="errors.name_jpn" class="text-sm text-danger">{{ errors.name_jpn[0] }}</p>          
        </div>
        <div class="mt-4">
            <label class="block mb-1" for="yamato_id">Yamato Id</label>
            <InputText
                v-model="deliveryType.yamato_id"
                name="yamato_id"
                type="text"
                placeholder="(Optional)"
                class="w-full"
                />      
                <p v-if="errors.yamato_id" class="text-sm text-danger">{{ errors.yamato_id[0] }}</p>          
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.create') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits} from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';

//prime vue components
import InputText from 'primevue/inputtext';

const emit = defineEmits(['created']);

const deliveryType = ref({
    name : '',
    name_jpn : '',
    yamato_id : ''
})
const errors = ref({});
const loading = ref(false);

const createDeliveryType = () => {
    loading.value = true;
    const id = toast.loading('Creating, please wait . . .');
    ApiService.post('delivery-types' , deliveryType.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Created delivery type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('created');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error creating delivery type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'error',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}
</script>

<style scoped>

</style>